import axios from "axios";
import { getToken, clearAuthStorage } from "../utils/authStorage";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5010/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle unauthorized responses (invalid/expired token)
    if (error.response?.status === 401) {
      // Clear token from storage
      clearAuthStorage();

      // Only redirect if we're not already on the login page
      if (!window.location.pathname.includes("/login")) {
        // Dispatch a custom event to notify AuthContext
        window.dispatchEvent(new CustomEvent("auth-token-expired"));

        // Use setTimeout to avoid potential navigation conflicts
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      }
    }
    // For 403 (Forbidden/Insufficient Permissions), do NOT log out
    // Just show error message to user - they're authenticated but lack permission
    return Promise.reject(error);
  }
);

export default api;
